import React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';

import { HOME_URL, CONTACT_US_URL } from 'app/router/constants/externalUrls';
import StackedLayout from 'app/components/layout/StackedLayout';
import Styled from 'app/components/errorPages/HeroBlock.styled';
import Heading from 'app/components/layout/Heading.styled';
import Text from 'app/components/layout/Text.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';

const OfferUnavailable = () => (
  <StackedLayout hasMarginTop>
    <FormattedMessage id="offer_unavailable_page_meta_title">
      {title => (
        <Helmet>
          <meta charSet="utf-8" />
          <title>{title}</title>
        </Helmet>
      )}
    </FormattedMessage>
    <StackedLayout.ContentBlock isContained>
      <Styled.HeroBlock>
        <Styled.Content data-t="hero-block">
          <Heading size="xl" as={Styled.Title} type="heavy">
            <FormattedMessage
              id="offer_unavailable_hero_title"
              values={{ linebreak: <Styled.TitleLinebreak /> }}
            />
          </Heading>
          <Text as={Styled.Subtitle} size="xl">
            <FormattedMessage
              id="offer_unavailable_hero_subtitle"
              values={{ linebreak: <Styled.SubtitleLinebreak /> }}
            />
          </Text>
          <Styled.ButtonHolder>
            <Styled.HeroBlockButton as={LocalizedLink} type="one" to={HOME_URL}>
              <FormattedMessage id="buttons_learn_more" />
            </Styled.HeroBlockButton>
            <Styled.HeroBlockButton
              as={LocalizedLink}
              type="oneWeak"
              to={CONTACT_US_URL}
            >
              <FormattedMessage id="buttons_contact_us" />
            </Styled.HeroBlockButton>
          </Styled.ButtonHolder>
        </Styled.Content>
        <Styled.ImageHolder>
          <Styled.Image
            data-t="hero-image"
            src={`${window.etp.config.assetsUrl}img/chibi/chibi.png`}
            srcSet={`${window.etp.config.assetsUrl}img/chibi/chibi@2x.png 2x`}
            alt="Hime"
          />
        </Styled.ImageHolder>
      </Styled.HeroBlock>
    </StackedLayout.ContentBlock>
  </StackedLayout>
);

export default OfferUnavailable;
